import template from './estates-trashbin-table.pug';

export const EstatesTrashbinTableComponent = {
  template,

  bindings: {
    filter: '<',
    onFilterChange: '&',
    gridOptions: '<',
    onCheck: '&',
    checkedIds: '<'
  },

  controller: class EstatesTrashbinTableComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {
    }

    applyFilter({ filter }) {
      this.onFilterChange({ $event:{ filter } });
    }

    checkIds({ checkedIds }) {
      this.onCheck({ $event: { checkedIds } });
    }

  }
};

